import classNames from 'classnames'
import { navigate } from 'gatsby'
import React, { ReactNode, useContext } from 'react'

import { PlainProduct } from '../../hooks/useProducts'
import { LocaleContext } from '../../locale/i18n'
import { staticPagePaths } from '../../locale/pathing'
import { ProductFiltersByType } from '../../logic/productFiltering'
import { StaticPage } from '../../logic/staticPage'
import Button from '../Button'
import { FilterableProductListProps } from '../FilterableProductList'

import ProductListItem from './ProductListItem'

import './ProductListing.scss'

const CardNotAllListed = () => {
  const { t } = useContext(LocaleContext)

  return (
    <div className="flex flex-col justify-center overflow-hidden rounded-lg border border-transparent bg-primary-light p-6 px-4 py-3 text-center text-sm wrap-anywhere text-text">
      <h4 className="color-heading mb-4 font-primary leading-1.5 font-medium">
        {t('productListing.noResultsCardHeading')}
      </h4>
      <p>{t('productListing.noResultsCardBody')}</p>
      <Button
        onClick={() => navigate(`${location.pathname}#askForOffer`)}
        className="mt-4"
        size="lg"
      >
        {t('common.contactUs')}
      </Button>
    </div>
  )
}

export const ProductListing = ({
  filters,
  products,
  className,
}: {
  filters: ProductFiltersByType
  onFilterChange: FilterableProductListProps['onFilterChange']
  products: PlainProduct[]
  className?: string
}) => {
  const { interpolate, locale, t } = useContext(LocaleContext)

  const items: ReactNode[] = []
  products.forEach(product => {
    items.push(
      <ProductListItem
        key={`product-${product.id}`}
        filters={filters}
        product={product}
      />,
    )
  })
  items.splice(
    Math.min(8, products.length),
    0,
    <CardNotAllListed key="banner-not-finding" />,
  )

  return (
    <section
      className={classNames(className, 'productListing', {
        'productListing--grid': products.length > 0,
      })}
    >
      {products.length > 0 ? (
        items
      ) : (
        <div className="productListing__noResults">
          <h2 className="productListing__heading">
            {interpolate(
              filters.deviceType.value ||
                filters.industryOrMaterial.value ||
                filters.typeOfTesting.value ||
                filters.deviceType.value
                ? 'productListing.noResultsHeadingFiltered'
                : 'productListing.noResultsHeading',
              {
                query: filters.text.value,
              },
            )}
          </h2>
          <p>{t('productListing.noResultsBody')}</p>
          <Button
            size="xl"
            onClick={e => {
              e.currentTarget.blur()
              void navigate(staticPagePaths[StaticPage.CONTACT][locale])
            }}
          >
            {t('common.contactUs')}
          </Button>
        </div>
      )}
    </section>
  )
}
